// extracted by mini-css-extract-plugin
export default {"buttons":"ThreadEditModal_buttons__SiLx0","deleteButton":"ThreadEditModal_deleteButton__PrZOt","editButton":"ThreadEditModal_editButton__2F8h3"};